import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types'
import withStyles from "@material-ui/styles/withStyles";
import FieldWrapper from "../../FieldWrapper";
import {FormControl} from "@material-ui/core";
import findByString from "../../Utils/getValueByString";
import update from "immutability-helper";
import {errorHandler} from "../../Utils/errorHandler";
import FieldErrorMessage from "../../Utils/errorMessage";
import {setArrayPath} from "../../Utils/setArrayPath";
import {checkHidden} from "../../Utils/checkHidden";
import SimpleField from "./SimpleField";
import ArrayField from "./ArrayField";
import {SwitchType} from "./SwitchField";
import CheckboxField from "./CheckboxField";
import RadioField from "./RadioField";

const styles = () => ({
    fieldWrapper: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        position: 'relative'
    },
    formControl: {
        minWidth: 'auto'
    }
});

const SelectType = (props) => {
    const {
        onBlurFromCell, field, focusNow, ignoreError, id,
        setValue, onBlur: onBlurFn,
        classes, doActions, setValueOnChange,
        fieldStyles, labelStyles, renderOptions, showLabel,
        goBack, errors = [], isMobile, globalValues, fieldPresentation,
        actionsContext, screenName, containerArrayPath,
        events: sourceEvents,
        values: sourceValues,
        field: {
            isArray,
            disabled,
            type,
            optLabel,
            trackChange,
            label,
            required,
            autofocus,
            hideCondition,
            placeholder,
            path: sourcePath,
            values: optValues
        },
    } = props;
    const [events, setEvents] = useState({onChange: null, onBlur: null});
    const [values, setValues] = useState({});
    const [options, setOptions] = useState([]);
    const [fieldValue, setFieldValue] = useState("");
    const [initialValue, setInitialValue] = useState("");
    const [isChanged, setIsChanged] = useState(false);
    const [path, setPath] = useState("");
    const [error, setError] = useState(false);
    const fieldRef = useRef(null);

    useEffect(() => {
        if (sourceEvents.length) {
            getEvents();
        }
        if (focusNow && field.disabled) {
            onBlurFromCell();
        }
        if (focusNow) {
            fieldRef.current.focus()
        }
        if (errors) {
            let errorField = errorHandler(errors, field.path, containerArrayPath);
            if (errorField) {
                setError(errorField)
            }
            if(!errorField && error) {
                setError(false)
            }
        }
        getValues();
    }, [])

    useEffect(() => {
        if (sourcePath) {
            getValues();
        }
    }, [sourceValues, sourcePath, JSON.stringify(optValues)])

    useEffect(() => {
        if (errors) {
            getErrors()
        }
    }, [errors])

    const getValues = () => {
        let arrayPath = setArrayPath(sourcePath, containerArrayPath);
        let value = findByString(sourceValues, arrayPath ? arrayPath : sourcePath);

        const options = getOptions(type, optValues);
        const objValue = getFieldValue(isArray, value, options);
        setOptions(options)
        setInitialValue(objValue)
        setFieldValue(objValue)
        setValues(values)
        setPath(arrayPath ? arrayPath : sourcePath)
    };
    const getErrors = () => {
        let errorField = errorHandler(errors, path, containerArrayPath);
        if (errorField) {
            setError(errorField)
        }
        if(!errorField && error) {
            setError(false)
        }

    };
    const getEvents = () => {
        const currentEvents = {
            onChange: null,
            onBlur: null
        };
        //subscribe to events
        if (sourceEvents.length) {
            for (let event of sourceEvents) {
                currentEvents[event.event] = event.actions
            }
        }
        setEvents(currentEvents)
    };
    const getOptions = (type, options = []) => {
        if (type === 'bool') {
            return [{label: "True", value: true}, {label: "False", value: false}]
        }
        if (type === 'objSelect') {
            return options.map((v, i) => {
                return v && {...v, idx: `${v[optLabel || 'value']}_${i}`, _index: i}
            });
        }
        if(type === 'integer') {
            return options.map((v, i) => {
                return {value: Number(v), label: v, idx: `${v}_${i}`}
            })
        }
        return options.map((v, i) => {
            return {value: v, label: v, idx: `${v}_${i}`}
        })
    };

    const getFieldValue = (isArray, value, options) => {
        if (isArray) {
            if (type === 'objSelect') {
                if (value && Array.isArray(value)) {
                    return value.map((v, i) => {
                        return {
                            value: typeof v === 'object' ? v.value : v,
                            label: getValueByName(v, options, optLabel),
                            idx: v ? `${v[optLabel]}_${i}` : ""
                        }
                    });
                } else {
                    return [];
                }

            } else {
                if (value) {
                    return value.map((v, i) => {
                        return {value: v, label: v, idx: `${v}_${i}`}
                    });
                } else {
                    return [];
                }
            }

        } else {
            if (type === 'objSelect') {
                if (value !== undefined) {
                    return {value, label: getValueByName(value, options, optLabel)}
                }
            }
            if (value !== undefined) {
                return {label: getValueByName(value, options, optLabel), value: value}
            } else {
                return null
            }
        }
    };

    const swapItems = (dragIndex, hoverIndex) => {
        let newArr = update(fieldValue, {
            $splice: [[dragIndex, 1], [hoverIndex, 0, fieldValue[dragIndex]]],
        });
        setFieldValue(newArr)
        setIsChanged(true)
    };
    const endDrag = () => {
        let fValue = type === 'objSelect' ? fieldValue.map(v => {
            delete v.idx;
            return v.value
        }) : fieldValue.map(v => {
            return v.value
        });
        setValue(fValue, path, trackChange)
    };

    const onChange = (event, value) => {
        const valueIndex = value ? value._index : null;
        setFieldValue(value !== undefined ? value : '')
        setIsChanged(true)
        const fValue = isArray ?
            type === 'objSelect' ?
                (value || []).map((v => {
                    delete v.idx;
                    return v.value
                })) :
                value.map(v => {
                    return v.value
                }) :
            value ? value.value : null;
        if (events.onChange) {
            doActions(events.onChange, {currentField: {value: value?.value}})
        }
        setValue(fValue, path, trackChange, valueIndex);
    };

    const onBlur = () => {
        onBlurFn && onBlurFn(fieldValue !== null ? fieldValue.value : undefined, path)
        if (events.onBlur) {
            doActions(events.onBlur)
        }
        if (setValueOnChange) return;
        let fValue =
            !isArray ?
                fieldValue ?
                    fieldValue.value :
                    undefined :
                type === 'objSelect' ?
                    fieldValue ? fieldValue.map(v => {
                        delete v.idx;
                        return v.value
                    }) : []
                    :
                    fieldValue ? fieldValue.map(v => {
                        return v.value
                    }) : [];
        if (isChanged) {
            setIsChanged(false);
        }
        if (focusNow) {
            onBlurFromCell();
        }
    };

    const getInitialValue = () => {
        setIsChanged(false)
        setFieldValue(initialValue)
    };
    const isHidden = checkHidden({...globalValues, ...actionsContext}, hideCondition, screenName);
    const isDisabled = checkHidden({...globalValues, ...actionsContext}, disabled, screenName);

    return (
        <FieldWrapper
            isHidden={isHidden}
            fieldRef={fieldRef}
            fieldStyles={fieldStyles}
            labelStyles={labelStyles}
            showLabel={showLabel}
            label={label}
            goBack={goBack}
            focusNow={focusNow}
            setInitialValue={getInitialValue}
            changed={isChanged}
            required={required}
            isMobile={isMobile}
            globalValues={globalValues}
            screenName={screenName}
        >
            <FormControl classes={{root: classes.formControl}}
                         style={{width: fieldStyles.fullWidth ? '100%' : fieldStyles.width}}

                         fullWidth={isMobile ? true : fieldStyles.fullWidth}>
                {isArray ? (
                    <ArrayField
                        fieldValue={fieldValue}
                        error={error}
                        errors={errors}
                        options={options}
                        disabled={isDisabled}
                        required={required}
                        type={type}
                        onChange={onChange}
                        onBlur={onBlur}
                        fieldStyles={fieldStyles}
                        fieldRef={fieldRef}
                        classes={classes}
                        field={field}
                        swapItems={swapItems}
                        endDrag={endDrag}
                        autoFocus={autofocus}
                        path={path}
                        label={label}
                        isMobile={isMobile}
                        fieldPresentation={fieldPresentation}
                        placeholder={placeholder}
                    />
                ) : (
                    fieldStyles.presentation === 'switch' ? (
                        <SwitchType
                            setValue={onChange}
                            fieldValue={fieldValue}
                            path={path}
                        />
                    ) : fieldStyles.presentation === 'checkbox' ? (
                        <CheckboxField
                            setValue={onChange}
                            fieldValue={fieldValue}
                            path={path}
                        />
                    ) : fieldStyles.presentation === 'radio' ? (
                        <RadioField
                            setValue={onChange}
                            fieldValue={fieldValue}
                            path={path}
                        />
                    ) : (
                        <SimpleField
                            fieldValue={fieldValue}
                            options={options}
                            renderOptions={renderOptions}
                            disabled={isDisabled}
                            required={required}
                            type={type}
                            onChange={onChange}
                            onBlur={onBlur}
                            fieldStyles={fieldStyles}
                            fieldRef={fieldRef}
                            classes={classes}
                            field={field}
                            autofocus={autofocus}
                            error={error}
                            label={label}
                            isMobile={isMobile}
                            fieldPresentation={fieldPresentation}
                            placeholder={placeholder}
                            onBlurFn={onBlurFn}
                            screenName={screenName}
                            path={path}
                        />
                    )
                )}
                {!ignoreError && <FieldErrorMessage message={error}/>}
            </FormControl>
        </FieldWrapper>
    )

}

SelectType.propTypes = {
    errors: PropTypes.array,
    //the object of field
    field: PropTypes.shape({
        label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
        optLabel: PropTypes.string, //define label to show from options objects
        type: PropTypes.oneOf(['objSelect', 'bool', 'string']),
        path: PropTypes.string,
        values: PropTypes.array,
        autofocus: PropTypes.bool,
        isArray: PropTypes.bool,
        pattern: PropTypes.string,
        min: PropTypes.string,
        max: PropTypes.string,
        minLength: PropTypes.string,
        maxLength: PropTypes.string,
        required: PropTypes.bool,
        placeholder: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
    }),
    fieldStyles: PropTypes.object.isRequired,
    labelStyles: PropTypes.object.isRequired,
    values: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    renderOptions: PropTypes.func,
    setValue: PropTypes.func.isRequired,
    showLabel: PropTypes.bool,
    doActions: PropTypes.func,
    events: PropTypes.array,
    //for table fields
    focusNow: PropTypes.bool,
    onBlurFromCell: PropTypes.func,
    onBlur: PropTypes.func,
    globalValues: PropTypes.object
};

SelectType.defaultProps = {
    errors: [],
    events: [],
    goBack: () => {
    },
    setValue: () => {
    },
    values: {},
    labelStyles: {},
    fieldStyles: {},
    fieldPresentation: 'outlined'
};

export default withStyles(styles)(SelectType);

function getValueByName(value, options, optLabel) {
    let filtered = [];
    if (typeof value === 'object') {
        //stringify to check equality of obj or arr
        filtered = options.filter(o => JSON.stringify(o.value) === JSON.stringify(value));
    } else {
        filtered = options.filter(o => o && o.value === value);
    }

    let fullValue = filtered.length ? filtered[0] : value;

    return fullValue ? fullValue[optLabel ? optLabel : 'label'] : ""
}